"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.pushErrorMessage = pushErrorMessage;
exports["default"] = pushLogMessage;
exports.pushGenericLogMessage = pushGenericLogMessage;
exports.pushVideoUsageLogMessage = pushVideoUsageLogMessage;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _reflux = _interopRequireDefault(require("reflux"));

var _LogActions = _interopRequireDefault(require("./Stores/LogActions2"));

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

/**
 * Created by falknisius on 12.06.17.
 */
var util = require('util'); // ensure instance id is generated


_RegisterInstance["default"].init();

var sanitizePath = function sanitizePath(id, path) {
  id = id.toString();
  if (path === null) return '!' + id;
  path = path.toString();
  if (path.length === 0) return '!' + id;

  while (path.substring(0, 1) === '!' && path.length > 1) {
    path = path.substring(1);
  }

  var elements = path.split('!');
  var lastElement = elements.pop();

  while (lastElement === '') {
    lastElement = elements.pop();
  }

  if (lastElement) elements.push(lastElement);
  if (lastElement.toString() !== id) elements.push(id);
  return '!' + elements.join('!');
};

function pushErrorMessage(messageDisplayedToUser, error) {
  var message = {
    type: 'error',
    messageToUser: util.inspect(messageDisplayedToUser),
    error: util.inspect(error)
  };
  console.log('sending error message', message);

  _LogActions["default"].logMessageEnqueueAction(message);
}
/**
 *
 * @param id     - the content element's id
 * @param path   - the path to the content element
 *
 * build a message enhanced with the applicationInstanceId, and localTimestamp
 * store it async in a local persistent queue
 */


function pushLogMessage(_x, _x2) {
  return _pushLogMessage.apply(this, arguments);
}

function _pushLogMessage() {
  _pushLogMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(id, path) {
    var message;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = id;
            _context.t1 = sanitizePath(id, path);
            _context.t2 = new Date().getTime();
            _context.next = 5;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 5:
            _context.t3 = _context.sent;
            message = {
              id: _context.t0,
              type: 'content',
              path: _context.t1,
              deviceUTCTime: _context.t2,
              applicationInstanceId: _context.t3
            };

            _LogActions["default"].logMessageEnqueueAction(message);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _pushLogMessage.apply(this, arguments);
}

function pushGenericLogMessage(messageJson) {
  _LogActions["default"].logMessageEnqueueAction(messageJson);
}

function pushVideoUsageLogMessage(_x3, _x4, _x5, _x6) {
  return _pushVideoUsageLogMessage.apply(this, arguments);
}

function _pushVideoUsageLogMessage() {
  _pushVideoUsageLogMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, path, sequences, chapters) {
    var message;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = id;
            _context2.t1 = sequences;
            _context2.t2 = chapters;
            _context2.t3 = sanitizePath(id, path);
            _context2.t4 = new Date().getTime();
            _context2.next = 7;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 7:
            _context2.t5 = _context2.sent;
            message = {
              id: _context2.t0,
              type: 'video',
              sequences: _context2.t1,
              chapters: _context2.t2,
              path: _context2.t3,
              deviceUTCTime: _context2.t4,
              applicationInstanceId: _context2.t5
            };

            _LogActions["default"].logMessageEnqueueAction(message);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _pushVideoUsageLogMessage.apply(this, arguments);
}